export const platformAdminNavigation = {
  links: {
    portal: "ポータル",
    platformAdmin: "プラットフォーム管理",
    examAdmin: "試験管理",
  },
  menu: {
    domainOverview: "概要",
    domainPortal: "ポータル",
    domainGovernance: "ガバナンス",
    domainResource: "リソース",
    domainRuntime: "実行",
    domainCapability: "能力",
    dashboard: "概要",
    applications: "業務入口",
    portalManagement: "ポータル管理",
    portalGroups: "ポータル分组",
    portalAppearance: "ポータル外観",
    portalUiSemantics: "UI セマンティクス",
    portalEntries: "入口編成",
    portalAccess: "接入設定",
    portalSecurity: "セキュリティ方針",
    identity: "統合認証",
    identityApplications: "ID 接続アプリ",
    identityUsers: "プラットフォームユーザー",
    identityTenants: "テナント",
    identityOrganizations: "組織",
    identityRoles: "プラットフォームロール",
    identityPermissions: "権限点",
    identityEvents: "ID 監査",
    identityLoginRecords: "ログイン記録",
    identityUserCustomFields: "ユーザーカスタム項目",
    assets: "アセット",
    execution: "実行基盤",
    centers: "プラットフォーム入口とセンター",
  },
} as const;
